<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="truck" class="mr-2"></b-icon>Ta'minotchi hisoboti</h2>
        </div>
        <button class="rp-btn rp-btn-secondary" @click="exportCsv" :disabled="loading || items.length === 0">
          <b-icon icon="file-earmark-excel"></b-icon> Excel
        </button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter">
          <label>Qidiruv</label>
          <input type="search" v-model="search" placeholder="Ta'minotchi...">
        </div>
        <div class="rp-filter"><label>&nbsp;</label><button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button></div>
      </div>

      <div class="rp-summary rp-summary-3" style="grid-template-columns: 1fr 1fr 1fr;">
        <div class="rp-card rp-c-1">
          <div class="rp-card-label">JAMI TA'MINOTCHI</div>
          <div class="rp-card-value">{{ filtered.length }}</div>
        </div>
        <div class="rp-card rp-c-3">
          <div class="rp-card-label">SO'M QARZ</div>
          <div class="rp-card-value" :class="totals.end_balance >= 0 ? 'rp-red' : 'rp-green'">
            {{ fmt(totals.end_balance) }} <small class="rp-muted">so'm</small>
          </div>
        </div>
        <div class="rp-card rp-c-2">
          <div class="rp-card-label">DOLLAR QARZ</div>
          <div class="rp-card-value" :class="totals.end_balance_dollar >= 0 ? 'rp-red' : 'rp-green'">
            $ {{ fmt(totals.end_balance_dollar) }}
          </div>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title">
          <b-icon icon="list-ul"></b-icon> Ta'minotchilar ro'yxati
          <span class="rp-badge rp-badge-info ml-2">Dollar va so'm alohida</span>
        </h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th rowspan="2">#</th>
                <th rowspan="2">Ta'minotchi</th>
                <th rowspan="2">Telefon</th>
                <th colspan="4" class="t-center supplier-som-th">SO'M kesimida</th>
                <th colspan="4" class="t-center supplier-usd-th">DOLLAR ($) kesimida</th>
              </tr>
              <tr>
                <th class="t-right supplier-som-th">Boshlang'ich</th>
                <th class="t-right supplier-som-th">Yetkazildi</th>
                <th class="t-right supplier-som-th">To'landi</th>
                <th class="t-right supplier-som-th">Qarz</th>
                <th class="t-right supplier-usd-th">Boshlang'ich</th>
                <th class="t-right supplier-usd-th">Yetkazildi</th>
                <th class="t-right supplier-usd-th">To'landi</th>
                <th class="t-right supplier-usd-th">Qarz</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in filtered" :key="r.kontragent_id">
                <td><span class="rp-num">{{ i + 1 }}</span></td>
                <td class="rp-strong">{{ r.kontragent_name }}</td>
                <td class="rp-muted">{{ r.phone_number || '—' }}</td>
                <!-- SO'M -->
                <td class="t-right">{{ fmt(r.begin_balance) }}</td>
                <td class="t-right rp-red">{{ fmt(r.supply_total) }}</td>
                <td class="t-right rp-green">{{ fmt(r.paid_total) }}</td>
                <td class="t-right rp-strong" :class="r.end_balance > 0 ? 'rp-red' : (r.end_balance < 0 ? 'rp-green' : '')">{{ fmt(r.end_balance) }}</td>
                <!-- DOLLAR -->
                <td class="t-right">{{ fmt(r.begin_balance_dollar) }}</td>
                <td class="t-right rp-red">{{ fmt(r.supply_total_dollar) }}</td>
                <td class="t-right rp-green">{{ fmt(r.paid_total_dollar) }}</td>
                <td class="t-right rp-strong" :class="r.end_balance_dollar > 0 ? 'rp-red' : (r.end_balance_dollar < 0 ? 'rp-green' : '')">{{ fmt(r.end_balance_dollar) }}</td>
              </tr>
              <tr v-if="!loading && filtered.length === 0"><td colspan="11" class="rp-empty">Ta'minotchi topilmadi</td></tr>
            </tbody>
            <tfoot v-if="filtered.length > 0">
              <tr>
                <th colspan="3" class="t-right">JAMI:</th>
                <th></th>
                <th class="t-right">{{ fmt(totals.supply_total) }}</th>
                <th class="t-right">{{ fmt(totals.paid_total) }}</th>
                <th class="t-right">{{ fmt(totals.end_balance) }}</th>
                <th></th>
                <th class="t-right">$ {{ fmt(totals.supply_total_dollar) }}</th>
                <th class="t-right">$ {{ fmt(totals.paid_total_dollar) }}</th>
                <th class="t-right">$ {{ fmt(totals.end_balance_dollar) }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, skladList: [], items: [],
      totals: {
        supply_total: 0, paid_total: 0, end_balance: 0,
        supply_total_dollar: 0, paid_total_dollar: 0, end_balance_dollar: 0,
      },
      search: '', loading: false,
    };
  },
  computed: {
    filtered() {
      if (!this.search || this.search.length < 2) return this.items;
      const q = this.search.toLowerCase();
      return this.items.filter(r => r.kontragent_name && r.kontragent_name.toLowerCase().includes(q));
    }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/suppliers/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        this.items = r.data.items || [];
        this.totals = r.data.totals || this.totals;
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    exportCsv() {
      const h = [
        'Taminotchi', 'Tel',
        'SOM Boshlangich', 'SOM Yetkazildi', 'SOM Tolandi', 'SOM Qarz',
        'USD Boshlangich', 'USD Yetkazildi', 'USD Tolandi', 'USD Qarz',
      ];
      const rows = this.filtered.map(r => [
        r.kontragent_name, r.phone_number,
        r.begin_balance, r.supply_total, r.paid_total, r.end_balance,
        r.begin_balance_dollar, r.supply_total_dollar, r.paid_total_dollar, r.end_balance_dollar,
      ]);
      const csv = [h, ...rows].map(x => x.map(c => `"${String(c||'').replace(/"/g,'""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿"+csv], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `taminotchilar_${this.date1}_${this.date2}.csv`; a.click();
    }
  }
};
</script>

<style scoped>
/* SO'M va DOLLAR ustun guruhlarini vizual ajratish */
.supplier-som-th { background: #f0f9ff !important; color: #0369a1 !important; border-bottom-color: #bae6fd !important; }
.supplier-usd-th { background: #ecfdf5 !important; color: #047857 !important; border-bottom-color: #a7f3d0 !important; }
.rp-table td:nth-child(8), .rp-table td:nth-child(9), .rp-table td:nth-child(10), .rp-table td:nth-child(11) {
  background: #f0fdf4;
}
</style>
